import { render, staticRenderFns } from "./LayoutEcogreenAdapter.vue?vue&type=template&id=5594a773&scoped=true&"
import script from "./LayoutEcogreenAdapter.vue?vue&type=script&lang=js&"
export * from "./LayoutEcogreenAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594a773",
  null
  
)

export default component.exports